// Lookups owned by the HR Info tab's leave allotment. Leave categories belong to the active organization,
// which stands for the country of employment.
import { buildPagingLiteral, buildWhereLiteral } from '@/lib/graphql-query-builder';

export const buildGetLeaveCategoriesLookupQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    LeaveCategorys: getLeaveCategorys(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Title
        LeaveLimit
        IsUnlimited
      }
    }
  }
`;
